module.exports = __webpack_public_path__ + "img/painting.2bab8a9.jpg";